import { render, staticRenderFns } from "./SpaceFeaturesPage.vue?vue&type=template&id=14d66a1c"
import script from "./SpaceFeaturesPage.vue?vue&type=script&lang=ts"
export * from "./SpaceFeaturesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports